import { ObjectUtils } from './object-utils';
var ApiData = /** @class */ (function () {
    function ApiData(apiData) {
        this.blocksNumbers = {
            total: 0,
            before: 0,
            after: 0,
            mainIndex: -1,
        };
        var data = ObjectUtils.copy(apiData);
        this.apiData = data;
        this.blocksBefore = [];
        this.blocksAfter = [];
        this.mainBlock = null;
        this.mainContents = null;
        if (data.main_contents) {
            this.mainContents = data.main_contents;
        }
        if (data.blocks && (data.blocks || []).length) {
            this.blocksNumbers.total = (data.blocks || []).length;
            for (var i = 0; i < (data.blocks || []).length; ++i) {
                if (data.blocks[i].type === 'mainblock') {
                    this.mainBlock = data.blocks[i];
                    this.blocksNumbers.mainIndex = i;
                    break;
                }
            }
            this.blocksNumbers.before = (this.blocksBefore || []).length;
            this.blocksNumbers.after = (this.blocksAfter || []).length;
        }
    }
    Object.defineProperty(ApiData.prototype, "mainblock", {
        get: function () {
            return this.mainBlock;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ApiData.prototype, "main_contents", {
        get: function () {
            return this.mainContents;
        },
        enumerable: true,
        configurable: true
    });
    ApiData.prototype.hasMainblock = function () {
        return typeof this.mainBlock !== 'undefined' && this.mainBlock !== null;
    };
    ApiData.prototype.hasMainContents = function () {
        return typeof this.mainContents !== 'undefined' && this.mainContents !== null;
    };
    ApiData.prototype.typeIs = function (type) {
        return this.hasMainContents()
            ? this.mainContents.content_type === type
            : false;
    };
    return ApiData;
}());
export { ApiData };
